const catalogDefaults = [{
    "titles": {
        "en": "Catalog",
        "ru": "Каталог",
        "uk": "Каталог"
    },
    "schemaId": "Exhibition"
}];
export interface Catalog {
    titles: Record<string, string>;
    schemaId: string;
}

export default catalogDefaults;